var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React from 'react';
import { CollaboratorTicket } from '../../modules/Reports/Model';
import { RenderExpiration } from './Expiration';
import { RenderIdaVuelta } from './IdaVuelta';
import { BlockLogo } from './Blocks/BlockLogo';
import { Align, FontSize } from '../../modules/ReceiptLayouts/Model';
import { PrintRefund } from './PrintRefund';
import { BlockUser } from './Blocks/BlockUser';
import { BlockDate } from './Blocks/BlockDate';
import { BlockService } from './Blocks/BlockService';
import { BlockSeparator } from './Blocks/BlockSeparator';
import { BlockCheckins } from './Blocks/BlockCheckins';
import { BlockPayments } from './Blocks/BlockPayments';
import { BlockQR } from './Blocks/BlockQR';
import { BlockTexto } from './Blocks/BlockTexto';
import { BlockSpaces } from './Blocks/BlockSpaces';
import { BlockAditionalInfo } from './Blocks/BlockAditionalInfo';
import { Texto } from './Texto';
import { BlockExtras } from './Blocks/BlockExtras';
import { BlockDataContact } from './Blocks/BlockDataContact';
import { BlockWeb } from './Blocks/BlockWeb';
import { inject, observer } from 'mobx-react';
import { Button, DatePicker } from '../../elements';
import { Card } from 'reactstrap';
import { T } from '../../helpers/i18n';
import { BlockAfiliate } from './Blocks/BlockAfiliate';
import { BlockAdditionalNote } from './BlockAdditionalNote';
import theme from '../../Theme';
import { Modal } from '../index';
import { loading } from '../../elements/Loading';
import MultiSelect from '../MultiSelect';
import { twoDigits } from '../../helpers/Utils';
import { BlockUserRefund } from './Blocks/BlockUserRefund';
import { PaymentView } from './PaymentView';
export var TypeAction = {
    Refund: 'refund',
    ShowPay: 'showPay',
    Pay: 'pay',
    AdditionalNote: 'additionalNote',
    ChangeDatebook: 'changeDatebook',
    Rebook: 'rebook',
    Cancel: 'cancel',
};
// export const RenderTicket = (props: Props) => {
var RenderTicket = /** @class */ (function (_super) {
    __extends(RenderTicket, _super);
    function RenderTicket(props) {
        var _this = this;
        var _a, _b;
        _this = _super.call(this, props) || this;
        _this.hoursOptions = [];
        _this.state = {
            additionalNote: (_b = (_a = props.ticket) === null || _a === void 0 ? void 0 : _a.additionalNote) !== null && _b !== void 0 ? _b : '',
            // hideModalDatePicker: true,
            hourSelected: [],
            daySelected: null,
            buttonOkDisabled: true
        };
        return _this;
    }
    RenderTicket.prototype.shouldComponentUpdate = function (nextProps, nextState, nextContext) {
        var _a, _b, _c;
        var shouldComponentUpdate = nextState.daySelected !== this.state.daySelected ||
            nextProps.hideModalDatePicker !== this.props.hideModalDatePicker ||
            nextState.hourSelected !== this.state.hourSelected ||
            nextState.additionalNote !== this.state.additionalNote;
        if (nextState.daySelected !== this.state.daySelected) {
            if (nextState.daySelected && this.props.stretch) {
                console.log('this.state.daySelected && this.props.stretch');
                var daySelected_1 = nextState.daySelected;
                var disabledDays = (_a = this.props.stretch) === null || _a === void 0 ? void 0 : _a.disabledDays;
                var horasIda = (_b = this.props.stretch) === null || _b === void 0 ? void 0 : _b.horasIda;
                var disabledHours = ((_c = disabledDays.find(function (disabledDay) {
                    return disabledDay.year === daySelected_1.getFullYear() && disabledDay.month === daySelected_1.getMonth() && disabledDay.day === daySelected_1.getDate();
                })) === null || _c === void 0 ? void 0 : _c.hours) || [];
                this.hoursOptions = generateHoursOptions(horasIda, disabledHours);
            }
        }
        return shouldComponentUpdate;
    };
    RenderTicket.prototype.render = function () {
        var _this = this;
        var _a = this.props, ticket = _a.ticket, showPaymentMethod = _a.showPaymentMethod, onClick = _a.onClick, onPay = _a.onPay, index = _a.index, store = _a.store;
        var item = ticket;
        var totalToPay = store.tempDuePaymentsStore.totalToDue;
        var errorTotalToPay = item.totalDue && (totalToPay <= 0 || totalToPay > item.totalDue);
        var daySelected = this.state.daySelected;
        var stretch = this.props.stretch;
        /*let options = []
        if (daySelected && stretch) {
          const horasIda = stretch?.horasIda
          const disabledDays = stretch?.disabledDays
          const disabledHours = disabledDays.find(disabledDay =>
            disabledDay.year === daySelected.getFullYear() && disabledDay.month === daySelected.getMonth() && disabledDay.day === daySelected.getDate()
          )?.hours || []
          
          // console.log('RenderTicket - render() - daySelected: ', daySelected)
          // console.log('RenderTicket - render() - disabledHours: ', disabledHours)
          
          options = generateHoursOptions(horasIda, disabledHours)
        }*/
        var buttonOkDisabled;
        if (this.props.stretch.tramoHora) {
            buttonOkDisabled = !this.state.daySelected || this.state.hourSelected.length === 0;
        }
        else {
            buttonOkDisabled = !this.state.daySelected;
        }
        return (React.createElement("div", { style: {
                margin: 0,
                display: 'flex',
                flexDirection: 'column',
                // justifyContent: 'center',
                alignItems: 'center',
                /*border: '1px solid black',*/
                borderLeft: index !== 0 ? '1px solid black' : 'none',
                /*marginTop: 50,*/
                backgroundColor: 'white',
                padding: '1rem'
            } },
            (item.totalDue !== null && item.totalDue > 0 && !item.daterefund && !item.refund_id) && React.createElement(Card, { body: true, title: 'Esta venta tiene pendiente un pago' },
                React.createElement(PaymentView, { small: true, handleOnChangePay: onPay, item: ticket }),
                React.createElement(Button, { primary: true, disabled: errorTotalToPay, onClick: function () { return onClick(TypeAction.Pay); } }, T('payDue'))),
            React.createElement(PrintRefund, { ticket: ticket, onPrint: function () { return window.print(); }, onRefund: function () { return onClick(TypeAction.Refund, ticket); }, onClickChangeDatebook: function () {
                    onClick(TypeAction.ChangeDatebook, ticket);
                } }),
            React.createElement(BlockSeparator, null),
            React.createElement(BlockLogo, { image: item.image, align: Align.Center }),
            item.cartToken ?
                // @ts-ignore
                React.createElement(BlockWeb, { collaboratorName: item instanceof CollaboratorTicket || item.typeInstance === 'CollaboratorTicket' ? item.collaboratorName : undefined })
                :
                    // @ts-ignore
                    React.createElement(BlockUser, { user: item.terminal === 'marketplace' ? 'marketplace' : item.username, collaboratorName: item instanceof CollaboratorTicket || item.typeInstance === 'CollaboratorTicket' ? item.collaboratorName : undefined }),
            React.createElement(BlockDate, { fecha: item.datecheck }),
            React.createElement(BlockSeparator, null),
            item.daterefund && React.createElement(BlockUserRefund, { ticket: item }),
            item.daterefund && React.createElement(BlockSeparator, null),
            ticket.numberSI && React.createElement(Texto, { texto: 'Factura Simplificada nº', fontSize: FontSize.big }),
            React.createElement("h3", null, ticket.numberSI ? ticket.numberSI : ticket.boardingPass ? 'TARJETA EMBARQUE' : 'RECIBO'),
            ticket.externalCode &&
                React.createElement("p", null, ticket.externalCode),
            React.createElement(BlockDataContact, { ticket: ticket }),
            ticket.contact &&
                (ticket.contact.name !== '' ||
                    ticket.contact.telephone !== '' ||
                    ticket.contact.pickUpLocations !== '' ||
                    ticket.contact.dropOffLocations !== '' ||
                    ticket.contact.additionalInformation !== '' ||
                    ticket.contact.email !== '') && React.createElement(BlockSeparator, null),
            React.createElement(BlockService, { operationline: item.operationLineName, stretchName: item.stretchName, origin: item.origin, destination: item.destination }),
            React.createElement(BlockSeparator, null),
            React.createElement(BlockCheckins, { lines: item.lines }),
            React.createElement(BlockSeparator, null),
            React.createElement(BlockExtras, { item: item }),
            React.createElement(BlockAfiliate, { item: item }),
            React.createElement(BlockPayments, { item: item }),
            React.createElement(BlockQR, { ticket: item }),
            React.createElement(BlockSpaces, null),
            React.createElement(BlockTexto, { texto: 'Gracias por su visita' }),
            React.createElement(BlockSpaces, null),
            React.createElement(BlockAdditionalNote, { value: this.state.additionalNote, onChange: function (e) {
                    var value = e.target.value;
                    _this.setState({ additionalNote: value });
                }, onClick: function () {
                    item.additionalNote = _this.state.additionalNote;
                    _this.props.onClick(TypeAction.AdditionalNote, item);
                } }),
            React.createElement(BlockTexto, { texto: '**************************************' }),
            React.createElement(RenderExpiration, { item: item }),
            React.createElement(BlockSpaces, null),
            React.createElement(BlockAditionalInfo, { aditionalInfo: item.aditionalInfo }),
            item.vuelta && !item.hoponHopoff && React.createElement(RenderIdaVuelta, null),
            !item.daterefund && item.datevalited && item.numberScanned === 1 && React.createElement("img", { style: {}, alt: 'image', width: '90x', src: '/assets/images/valited.jpeg' }),
            !item.daterefund && item.datevalited && item.numberScanned === 2 &&
                React.createElement("div", null,
                    React.createElement("img", { style: {}, alt: 'image', width: '90px', src: '/assets/images/valited.jpeg' }),
                    React.createElement("img", { style: {}, alt: 'image', width: '90px', src: '/assets/images/valited.jpeg' })),
            item.daterefund &&
                React.createElement("img", { style: {}, alt: 'cancelled', width: '90px', src: '/assets/images/cancelled.png' }),
            React.createElement(Modal, { style: {
                // height: daySelected? '100%' : 'inherit'
                }, 
                // hide={this.state.hideModalDatePicker}
                hide: this.props.hideModalDatePicker, title: T('dateBook') },
                React.createElement(DatePicker, { name: 'changeDatebook', hideTodayButton: true, date: new Date(), min: new Date(), onChange: function (date, value) {
                        console.log('comprobando disponibilidad para fecha');
                        _this.setState({ daySelected: value });
                    }, onKeyPress: function () { } }),
                this.state.daySelected && React.createElement(MultiSelect, { className: '', inline: true, onlyOne: true, options: this.hoursOptions, value: this.state.hourSelected, onChange: function (value) {
                        _this.setState({ hourSelected: [value], buttonOkDisabled: false });
                    }, labelledBy: 'Select' }),
                React.createElement("div", { style: {
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        width: '100%'
                    } },
                    React.createElement(Button, { disabled: buttonOkDisabled, style: { backgroundColor: theme.color.background, margin: '5px' }, onClick: function () {
                            var hourSelected = _this.state.hourSelected[0].value;
                            if (_this.state.buttonOkDisabled) {
                                return;
                            }
                            // this.setState({hideModalDatePicker: true})
                            var year = daySelected.getFullYear();
                            var month = daySelected.getMonth();
                            var day = daySelected.getDate();
                            var hours = (hourSelected === null || hourSelected === void 0 ? void 0 : hourSelected.hours) || 0;
                            var minutes = (hourSelected === null || hourSelected === void 0 ? void 0 : hourSelected.minutes) || 0;
                            var data = {
                                year: year,
                                month: month,
                                day: day,
                                hours: hours,
                                minutes: minutes,
                                numero: ticket.numero,
                                userName: _this.props.store.users.user.username,
                                user_id: _this.props.store.users.user.id,
                                datebook: new Date(year, month, day, hours, minutes, 0, 0)
                            };
                            onClick(TypeAction.Rebook, data);
                        } }, 'OK'),
                    React.createElement(Button, { style: { backgroundColor: theme.color.background, margin: '5px' }, onClick: function () {
                            // 
                            // this.setState({hideModalDatePicker: true})
                            onClick(TypeAction.Cancel, null);
                        } }, 'Cancel')))));
    };
    RenderTicket = __decorate([
        inject('store'),
        loading(function (props) {
            var _a, _b;
            if (!!!props.ticket)
                return [];
            return [
                // @ts-ignore
                !!!((_a = props.ticket) === null || _a === void 0 ? void 0 : _a.operator_id) ?
                    props.store.stretches.read(props.ticket.stretch_id).then(function (value) {
                        return { stretch: value };
                    }) :
                    props.store.collaboratorStretchesStore.read({
                        stretch_id: (_b = props.ticket) === null || _b === void 0 ? void 0 : _b.stretch_id,
                        operator_id: props.ticket.operator_id,
                        client_id: props.ticket.client_id
                    }).then(function (value) {
                        console.log('stretch: ', value);
                        return { stretch: value };
                    })
            ];
        }),
        observer
    ], RenderTicket);
    return RenderTicket;
}(React.Component));
export { RenderTicket };
export var generateHoursOptions = function (horasIda, disabledHours) {
    // console.log('horasIda: ', horasIda)
    // console.log('disabledHours: ', disabledHours)
    var options = [];
    var _loop_1 = function (horaIda) {
        var disabled = !!disabledHours.find(function (disabledHour) { return disabledHour.hours === horaIda.hours && disabledHour.minutes === horaIda.minutes; });
        var option = {
            key: String(horaIda.id),
            value: horaIda,
            label: "".concat(twoDigits(horaIda.hours), ":").concat(twoDigits(horaIda.minutes)),
            disabled: disabled
        };
        options.push(option);
    };
    for (var _i = 0, horasIda_1 = horasIda; _i < horasIda_1.length; _i++) {
        var horaIda = horasIda_1[_i];
        _loop_1(horaIda);
    }
    console.log('generateOptions - options: ', options);
    return options;
};



//////////////////
// WEBPACK FOOTER
// ./src/components/Ticket/Ticket.tsx
// module id = 479
// module chunks = 0